import React from 'react';
import {useAppContext} from 'contexts/ApplicationContext';
import {CBCButton} from 'shared/helpers';
import {useJobDialog} from 'components/customer/Job/helpers/useJobDialog';

export const AddJob = () => {
    const {userProfile} = useAppContext();
    const {openJobDialog, jobDialog} = useJobDialog();

    return (
        <>
            <CBCButton
                id="create-new-job-button"
                iconName="Button-Add.svg"
                disabled={!!userProfile?.inActiveManufacturer}
                onClick={openJobDialog}>
                Create a New Job
            </CBCButton>
            {jobDialog}
        </>
    );
};
